/**
 * Datos de contacto e identidad comercial.
 *
 * IMPORTANTE: los valores marcados con corchetes [ ] son campos pendientes de
 * completar con la información real del negocio. No deben publicarse así:
 * reemplázalos por los datos verificados antes de poner la página en línea.
 * No se inventó ningún dato de contacto.
 */
export const business = {
  brand: 'Brujería Mayor',
  legalName: 'Templo La Luz del Mundo',
  phone: '+1 214 628 0996',
  phoneHref: '+12146280996',
  whatsapp: '+1 620 315 7206',
  whatsappHref: '16203157206',
  email: '',
  address: '3128 Coral Wy, Miami, FL 33145, EE. UU.',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=3128+Coral+Wy,+Miami,+FL+33145',
  country: 'Estados Unidos',
  hours: '',
  costsNote:
    'La consulta inicial es gratuita. Determinados servicios, materiales o llamadas pueden tener costos, que se informan de forma clara antes de contratarlos.',
}

export const whatsappMessage = 'Hola, quisiera información sobre una consulta.'

/** Devuelve el enlace de WhatsApp solo si hay un número configurado. */
export function getWhatsAppLink(): string | null {
  if (!business.whatsappHref) return null
  return `https://wa.me/${business.whatsappHref}?text=${encodeURIComponent(whatsappMessage)}`
}
